// Base URL resolution for CRA. Use REACT_APP_API_BASE_URL or default to /api (proxy/K8s)
const getApiBaseUrl = () => {
  const runtimeEnv = (typeof window !== 'undefined' && window.__ENV) || {};
  const env = runtimeEnv.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL;
  if (env) {
    return env.endsWith('/api') ? env : `${env.replace(/\/$/, '')}/api`;
  }
  return '/api';
};

export const API_BASE_URL = getApiBaseUrl();

export const apiUrl = (endpoint) => {
  const clean = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL.replace(/\/$/, '')}/${clean}`;
};


